<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/venta`;

function authHeaders() {
  return {
    'Authorization': `Bearer ${utilsService.getToken()}`,
    'Content-Type': 'application/json',
  };
}

// GET /api/venta/obtener/{id}
async function getVentaById(id) {
  const response = await axios.get(`${apiUrl}/obtener/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
}

// GET /api/venta/obtener/fecha/{fechaInicio}/{fechaFin}[?idEmpresa=n&idEmpresaCompradora=n&lang=es]
// fechaInicio y fechaFin en formato yyyy-MM-dd
async function getVentasByFecha(fechaInicio, fechaFin, idEmpresa = null, tipoFecha = 'FV', idEmpresaCompradora = null) {
  const lang = localStorage.getItem('language') || 'es';
  const params = { tipoFecha, lang };
  if (idEmpresa) params.idEmpresa = idEmpresa;
  if (idEmpresaCompradora) params.idEmpresaCompradora = idEmpresaCompradora;
  const response = await axios.get(`${apiUrl}/obtener/fecha/${fechaInicio}/${fechaFin}`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
}

// POST /api/venta/crear
async function crearVenta(data) {
  const response = await axios.post(`${apiUrl}/crear`, data, {
    headers: authHeaders(),
  });
  return response.data;
}

// POST /api/venta/crear-manual
async function crearVentaManual(data) {
  const response = await axios.post(`${apiUrl}/crear-manual`, data, {
    headers: authHeaders(),
  });
  return response.data;
}

// GET /api/venta/obtener/material/{idMaterial}
async function getVentasByMaterial(idMaterial) {
  const response = await axios.get(`${apiUrl}/obtener/material/${idMaterial}`, {
    headers: authHeaders(),
  });
  return response.data;
}

// PUT /api/venta/actualizar/{id}
async function actualizarVenta(id, venta, idUsuarioModificacion) {
  const response = await axios.put(`${apiUrl}/actualizar/${id}`, { venta, idUsuarioModificacion }, {
    headers: authHeaders(),
  });
  return response.data;
}

// DELETE /api/venta/eliminar/{id}
async function eliminarVenta(id, idUsuarioModificacion, observacionAnula) {
  const response = await axios.delete(`${apiUrl}/eliminar/${id}`, {
    headers: authHeaders(),
    data: { idUsuarioModificacion, observacionAnula },
  });
  return response.data;
}

export default {
  getVentaById,
  getVentasByFecha,
  crearVenta,
  crearVentaManual,
  actualizarVenta,
  getVentasByMaterial,
  eliminarVenta,
};
</script>
